import React from 'react';
import PropTypes from 'prop-types';

const AdditionalFormNeededAlert = ({
  formNumber,
  formLink,
  onlineLink,
  onlineLinkText,
  children,
}) => (
  <va-alert status="warning" class="vads-u-margin-bottom--4">
    <h4 slot="headline">Additional form needed</h4>
    {children}
    <p>
      <va-link href={onlineLink} external text={onlineLinkText} />
    </p>
    <p>
      <va-link
        href={formLink}
        external
        text={`Get VA Form ${formNumber} to download`}
      />
    </p>
  </va-alert>
);

AdditionalFormNeededAlert.propTypes = {
  children: PropTypes.node.isRequired,
  formLink: PropTypes.string.isRequired,
  formNumber: PropTypes.string.isRequired,
  onlineLink: PropTypes.string.isRequired,
  onlineLinkText: PropTypes.string.isRequired,
};

export const NursingHomeInformationAlert = () => (
  <AdditionalFormNeededAlert
    formNumber="21-0779"
    formLink="https://www.va.gov/forms/21-0779/"
    onlineLink="https://www.va.gov/supporting-forms-for-claims/submit-nursing-home-information-form-21-0779"
    onlineLinkText="Submit request for nursing home information in connection with claim for Aid and Attendance"
  >
    <p className="vads-u-margin-y--0">
      You’ll need to submit a Request for Nursing Home Information in Connection
      with Claim for Aid and Attendance (VA Form 21-0779). A nursing home
      official must complete this form.
    </p>
    <p>
      You can submit this form online, upload it at the end of this application,
      or send it to us by mail.
    </p>
  </AdditionalFormNeededAlert>
);

export const RegularAssistanceAlert = () => (
  <AdditionalFormNeededAlert
    formNumber="21-2680"
    formLink="https://www.va.gov/forms/21-2680/"
    onlineLink="https://www.va.gov/pension/aid-attendance-housebound/apply-form-21-2680"
    onlineLinkText="Apply for Aid and Attendance benefits or Housebound allowance"
  >
    <p className="vads-u-margin-y--0">
      You’ll need to submit an Examination of Housebound Status or Permanent
      Need for Regular Aid and Attendance (VA Form 21-2680). A licensed medical
      professional must complete this form.
    </p>
    <p>
      You can upload this document at the end of this application. Or you can
      send it to us by mail.
    </p>
  </AdditionalFormNeededAlert>
);
